import { Component, OnInit } from "@angular/core";
import { locale as italian } from "../../../../i18n/it";
import { UtilsService } from "../../../../auth/service/utils.service";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";

@Component({
  selector: "app-list-manager-contract",
  templateUrl: "./list-manager-contract.component.html",
  styleUrls: ["./list-manager-contract.component.scss"],
})
export class ListManagerContractComponent implements OnInit {
  public contentHeader: IContentHeader;

  public list_contracts_manager: any = [
    {
      title: "Indeterminato",
      type: "indeterminato",
    },
    {
      title: "Determinato",
      type: "determinato",
    },
    {
      title: "Apprendistato",
      type: "apprendistato",
    },
    {
      title: "Informativa privacy",
      type: "informativa-privacy",
    },
    {
      title: "Protezione dei dati",
      type: "protezione-dei-dati",
    },
  ];

  constructor(public _utilsService: UtilsService) {}

  async ngOnInit() {
    this.contentHeader = {
      headerTitle: italian.data.MENU.MANAGER_CONTRACT,
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: italian.data.MENU.MANAGE,
            isLink: true,
            link: "/dashboard/platform-management",
          },
          {
            name: italian.data.MENU.MANAGER_CONTRACT,
            isLink: false,
          },
        ],
      },
    };
  }
}
